import React from 'react';
import CSSModules from 'react-css-modules';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import size from 'lodash/size';

import UserCard from '../Card/UserCard';
import {
  CARE_PROVIDER,
  MAIN_CARE_PROVIDER,
  MEMBER_PROVIDER_CIRCLE,
} from '../../constants/strings';
import { TEAM_ICON } from '../../constants/chat';
import styles from './style.styl';

const getRole = (
  rawRole,
  isMainCareProvider = false,
  caregiver,
  formatMessage,
) => {
  const defaultProviderRole = isMainCareProvider
    ? MAIN_CARE_PROVIDER
    : MEMBER_PROVIDER_CIRCLE;
  const role = rawRole;

  if (role) return role;

  if (defaultProviderRole) return formatMessage(defaultProviderRole);

  return '';
};

const getNote = (provider, isTeamMember, formatMessage) => {
  const note =
    get(provider, 'primaryProviderProfile.role') ||
    formatMessage(CARE_PROVIDER);
  const organization = get(provider, 'organizationName');

  if (isTeamMember) return organization;

  return organization ? `${note}, ${organization}` : note;
};

const ProviderCircle = ({
  type,
  title,
  careProviders,
  relatedPatientId,
  mainCareProviderIndex,
  intl: { formatMessage },
}) =>
  size(careProviders) > 0 && (
    <div styleName="circle">
      <div styleName="provider-label">
        <span styleName="label">{title}</span>
      </div>
      {careProviders.map(provider => {
        const isTeamMember = get(provider, 'teamActingUser', false);
        const list = get(provider, 'providerCircle', []);
        const note = getNote(provider, isTeamMember, formatMessage);

        return (
          <div key={provider.id} styleName="provider">
            <div styleName="provider-header">
              <div styleName="user">
                <UserCard
                  className="ph3 pv2 fw6"
                  user={provider}
                  note={note}
                  size={40}
                  linkType={type}
                  relatedPatientId={relatedPatientId}
                  additionalIcons={isTeamMember ? [TEAM_ICON] : null}
                />
              </div>
            </div>
            {size(list) > 0 && (
              <ul styleName="provider-row">
                <div styleName="vl" />
                <div styleName="provider-column">
                  {list.map((item, i) => {
                    const role = getRole(
                      item.role,
                      i === mainCareProviderIndex,
                      item.caregiver,
                      formatMessage,
                    );
                    const providerOrganization = get(item, 'organizationName');

                    return (
                      <UserCard
                        linkType={type}
                        relatedPatientId={relatedPatientId}
                        key={item.id}
                        className="ph3 pv2 fw6"
                        user={item}
                        note={
                          providerOrganization
                            ? `${role}, ${providerOrganization}`
                            : role
                        }
                        size={40}
                      />
                    );
                  })}
                </div>
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );

ProviderCircle.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  careProviders: PropTypes.array,
  relatedPatientId: PropTypes.number,
  onOpen: PropTypes.func,
  mainCareProviderIndex: PropTypes.number,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default injectIntl(
  CSSModules(ProviderCircle, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/ProviderCircle.jsx